import { render, staticRenderFns } from "./BaseESignOnboarding.vue?vue&type=template&id=2e522222&scoped=true"
import script from "./BaseESignOnboarding.vue?vue&type=script&lang=js"
export * from "./BaseESignOnboarding.vue?vue&type=script&lang=js"
import style0 from "./BaseESignOnboarding.vue?vue&type=style&index=0&id=2e522222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e522222",
  null
  
)

export default component.exports